module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/sidebar-shield-inactive.8f21e72b.svg";